export const addfree = `<svg width="39" height="40" viewBox="0 0 39 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.4924 39.4998C8.75223 39.4998 -0.0379624 30.6791 0.000123297 19.939C0.038209 9.22926 8.79031 0.507622 19.5076 0.500005C30.225 0.492388 39.0304 9.30543 38.9999 20.0532C38.9695 30.7553 30.1945 39.4998 19.4924 39.4998ZM12.1419 31.5246C17.0016 34.9143 24.8244 34.6477 29.7603 29.1481C34.483 23.8846 33.9193 16.4351 30.9867 12.6874C24.7178 18.9487 18.4412 25.2253 12.1419 31.5246ZM26.8201 8.46754C22.4098 5.27596 14.8612 5.25311 9.81863 10.25C4.74561 15.2849 4.76084 22.8944 7.96004 27.3276L26.8201 8.46754Z" fill="url(#paint0_linear_985_9821)"/>
<defs>
<linearGradient id="paint0_linear_985_9821" x1="19.5" y1="0.446685" x2="19.5" y2="39.0611" gradientUnits="userSpaceOnUse">
<stop stop-color="#FDAE3E"/>
<stop offset="1" stop-color="#FF0749"/>
</linearGradient>
</defs>
</svg>
`;
